import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/platforme-auto-romania/")({
  head: () => routeHead("/platforme-auto-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/ghiduri/platforme-auto-romania-cum-alegi", statusCode: 301, replace: true });
  },
});
